import menu from '@/services/menu.service';
var state = {
    all: [],
    map: {},
    menuId: null
};
var getters = {
    allItems: function (state) { return state.all; },
    getMap: function (state) { return state.map; },
    getItem: function (state) { return function (assetId) {
        var item = state.map[assetId];
        if (!item) {
            return null;
        }
        return item;
    }; },
    hasItems: function (state) {
        var items = state.all;
        return (items.length > 0);
    },
    getSection: function (state) { return function (ids) {
        return state.all.filter(function (item) {
            return (ids.includes(item.id));
        });
    }; },
    getItemByParentAssetId: function (state) { return function (parentAssetId) {
        return state.all.find(function (item) {
            return item.parentAssetId === parentAssetId;
        });
    }; },
    getMenuId: function (state) {
        return state.menuId;
    }
};
var actions = {
    fetchAllItems: function (_a) {
        var commit = _a.commit;
        if (state.all.length === 0) {
            return menu.getMenuItems(function (items) {
                commit('setItems', items);
            });
        }
        return state.all;
    },
    // TODO: use for hard reload on single item detail
    fetchItem: function (_a, itemId) {
        var commit = _a.commit;
        return menu.getMenuItem(itemId, function (item) {
            commit('setItem', item);
        });
    },
    setItems: function (_a, items) {
        var commit = _a.commit;
        commit('setItems', items);
    },
    setMenuId: function (_a, menuId) {
        var commit = _a.commit;
        commit('setMenuId', menuId);
    }
};
var mutations = {
    setItems: function (state, items) {
        state.all = items;
        state.map = {};
        items.forEach(function (item) {
            state.map[item.assetId] = item;
            state.map[item.parentAssetId] = state.map[item.assetId];
            var vanityName = item.generateVanityName();
            state.map[vanityName] = state.map[item.assetId];
        });
    },
    setItem: function (state, item) {
        state.map[item.assetId] = item;
    },
    setMenuId: function (state, menuId) {
        state.menuId = menuId;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/item.store.ts
// module id = null
// module chunks = 